import { IMap } from "../types";

export const EmployeePositions: IMap<string> = {
  Operations: "Operations",
  Engineer: "Engineer",
  Business: "Business",
  Management: "Management",
  RandD: "Research & Development",
  Training: "Training",
  Unassigned: "Unassigned",
};
